import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { LinePlot } from "../components/LinePlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.line_tool_name()}
        toolPath="/line-chart"
      />
      <SciHeader title={m.line_h1()} intro={m.line_intro()} />

      <LinePlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.line_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.line_ex1(), m.line_ex2(), m.line_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.line_faq_q1(), a: m.line_faq_a1() },
          { q: m.line_faq_q2(), a: m.line_faq_a2() },
          { q: m.line_faq_q3(), a: m.line_faq_a3() },
          { q: m.line_faq_q4(), a: m.line_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
